import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { isString } from 'lodash-es';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { AuthStore } from '@store';

@Directive({
  selector: '[appForCountries]',
})
export class ForCountriesDirective implements OnDestroy {
  private isCountry: boolean;
  private countries: string[];
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Input('appForCountries') set forCountries(value: any) {
    if (!value) {
      this.viewContainer.clear();

      return;
    }
    const countries = isString(value) ? [value] : [...value];
    this.countries = countries.map((country) => country.toLocaleLowerCase());
    this.init();
  }

  constructor(
    private authStore: AuthStore,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) {}

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private init(): void {
    this.authStore
      .getCountryCode()
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter((code) => !!code),
        map((code) => code.toLocaleLowerCase())
      )
      .subscribe((country) => {
        const idx = this.countries.indexOf(country);
        this.isCountry = idx > -1;
        this.updateView();
      });
  }

  private updateView(): void {
    if (this.isCountry) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
